import React, { useState, useEffect } from 'react'
import { Grid, Paper, ButtonBase, Dialog, DialogTitle, DialogActions, Typography, Button, CardMedia, DialogContent } from "@mui/material";
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { completeTask } from '../../../api/APIServices';
import { useDispatch } from 'react-redux';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import mp3Image from '../../../assets/images/video-player.png'

const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
  borderRadius: '7px'
});

function Education({ education }) {
  const dispatch = useDispatch();

  const { t } = useTranslation('global');
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const markAsComplete = (taskId) => {
    dispatch(completeTask({ taskId: taskId }));
    setOpen(false);
  }



  return (
    <Paper
      sx={{
        p: 2,
        margin: '5px',
        minWidth: 500,
        boxShadow: 0,
        backgroundColor: '#c7d6df'
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <ButtonBase onClick={handleClickOpen} sx={{ width: 128, height: 128 }}>
            <Img alt="complex" src={mp3Image} />
          </ButtonBase>
        </Grid>
        <Grid item xs={8} sm container>
          <Grid item container direction="column" >
            <Grid item >
              <Grid item container direction="row" style={{ justifyContent: 'space-between' }} >
                <Typography gutterBottom variant="subtitle1" component="div" style={{flex: 1, }}>
                  {education.type}
                </Typography>
                {education?.isCompleted && <CheckCircleIcon color='green' style={{ color: 'green', flex: 0.3, alignContent: 'flex-end',justifyContent:'flex-end' }} />}
              </Grid>
              <Typography variant="body2" gutterBottom>
                {education.type}
              </Typography>

            </Grid>
            <Grid item>
              <Button
                size="small"
                type="button"
                variant="outlined"
                onClick={handleClickOpen}
              > Play </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              minWidth: "650px",
              minHeight: "400px",
              display: 'flex',
              fontFamily: 'Open Sans'// Set your width here
            },
            "& .MuiDialogContent-root": {
              padding: '10px'
            },
            "& .MuiDialogTitle-root": {
              padding: '10px 5px 0px 10px'
            }
          },
        }}
      >
        <DialogTitle id="alert-dialog-title"> {education.type} </DialogTitle>
        <DialogContent>
          <CardMedia
            component='video'
            image={education.audioUrl}
            controls
            width={640}
            height={380}
          />
        </DialogContent>
        <DialogActions>
          <Button color='primary' size='small'
            variant="contained"
            onClick={handleClose} autoFocus>
            {t('close')}
          </Button>
          <Button color='primary'
            size='small'
            variant="outlined"
            onClick={() => markAsComplete(education.taskId)}
            autoFocus>
            {t('mark_as_complete')}
          </Button>
        </DialogActions>
      </Dialog>
    </Paper>
  )
}

export default Education